var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block","margin-right":"10px"}},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"type":"file"},on:{"change":_vm.importExcel}}),_c('el-button',{staticClass:"button-el-el",attrs:{"type":"info"},on:{"click":_vm.onDerive}},[_vm._v("批量輸入")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }